module.exports = __webpack_public_path__ + "img/check.625968ef.svg";